import * as api from '../api';
import {
  shipmentTrackingDetailRequest,
  shipmentTrackingLineHaulRequest,
} from '../api/requestCreator';
import { setShipmentTracking } from '../analytics/gatherService';
import { ACTIONS } from '../constants';

const updateShipmentTrackingDetail = (
  dispatch: Function,
  shipmentTrackingDetail: Object,
  trackingNumber: string,
  groupIndex: string,
  filter: string,
) => {
  dispatch({
    type: 'FETCH_SHIPMENT_TRACKING_DETAIL_SUCCESS',
    response: shipmentTrackingDetail,
    id: `${trackingNumber}_${groupIndex}`,
    filter,
  });
};

const getLastMileShipment = (shipments: Array) => {
  if(shipments.length < 2) return shipments[0];
  const lastMile = shipments.filter((s: Object) => s.trackingType === "LastMile");
  return lastMile ? lastMile[0] : shipments[1];
};

const hideLineHaulCarrierName = (shipmentTrackingDetail: Object) => ({
  ...shipmentTrackingDetail,
  providerName: "Trucking Carrier",
})

const fetchShipmentTrackingDetail = (
  filter: string,
  isCarrierIntegrationAvailable: boolean,
  isLineHaul: boolean,
  providerCode: string,
  shipments: Array,
  groupIndex: string,
  orderNumber: String,
) => (dispatch: Function) => {
  // get first tracking number
  const { trackingNumber } = isLineHaul ? getLastMileShipment(shipments) : shipments[0];
  dispatch({
    type: ACTIONS.FETCH_SHIPMENT_TRACKING_DETAIL,
    id: trackingNumber,
    filter,
  });
  const orderId = orderNumber.toString();
  // integrated carrier
  if (isCarrierIntegrationAvailable) {
    // check for linehaul
    if (isLineHaul) {
      const payload = shipmentTrackingLineHaulRequest(shipments);
      const { url, data } = payload;
      api.postRequest(url, data).then(
        (response: Object) => {
          let { shipmentTrackingDetail } = response.data;
          shipmentTrackingDetail = hideLineHaulCarrierName(shipmentTrackingDetail);
          // update store with response
          updateShipmentTrackingDetail(
            dispatch,
            shipmentTrackingDetail,
            trackingNumber,
            groupIndex,
            filter,
          );
          // analytics - integrated linehaul tracking number: success
          setShipmentTracking(true, filter);
        },
        (error: Object) => {
          console.log(error);
          const nonInteratedTrackingDetail = {
            trackingNo: trackingNumber,
          };
          updateShipmentTrackingDetail(
            dispatch,
            nonInteratedTrackingDetail,
            trackingNumber,
            groupIndex,
            filter,
          );
          // analytics - integrated linehaul tracking number: failure
          setShipmentTracking(false, filter);
        }
      );
    } else {
      const url = shipmentTrackingDetailRequest(providerCode, trackingNumber, orderId);
      api.getRequest(url).then(
        (response: Object) => {
          const { shipmentTrackingDetail } = response.data;
          // update store with response
          updateShipmentTrackingDetail(
            dispatch,
            shipmentTrackingDetail,
            trackingNumber,
            groupIndex,
            filter,
          );
          // analytics - integrated carrier tracking number: success
          setShipmentTracking(true, filter);
        },
        (error: Object) => {
          console.log(error);
          const nonInteratedTrackingDetail = {
            trackingNo: trackingNumber,
          };
          updateShipmentTrackingDetail(
            dispatch,
            nonInteratedTrackingDetail,
            trackingNumber,
            groupIndex,
            filter,
          );
          // analytics - integrated carrier tracking number: failure
          setShipmentTracking(false, filter);
        }
      );
    }
  } else {
    // non-integrated carrier
    const nonInteratedTrackingDetail = {
      trackingNo: trackingNumber,
    };
    updateShipmentTrackingDetail(
      dispatch,
      nonInteratedTrackingDetail,
      trackingNumber,
      groupIndex,
      filter,
    );
    // analytics - non-integrated carrier tracking number: success
    setShipmentTracking(true, filter);
  }
};

export default fetchShipmentTrackingDetail;
